import { faLocationPin } from "@fortawesome/pro-regular-svg-icons";

import { FunctionComponent } from "react";

import { faLocationDot } from "@fortawesome/pro-light-svg-icons";

import { Icon } from "@/components";

import { ListPerson } from "@/pages/Private/pages/List/schema/list";

export const PersonLocation: FunctionComponent<{
	row: ListPerson;
}> = ({ row }) => {
	return (
		<div className="text-sm overflow-hidden  whitespace-nowrap text-ellipsis w-full flex flex-row items-center gap-1.5 min-w-0">
			{row.prospect?.country ? (
				<>
					<Icon className="text-gray-500 w-3.5 h-3.5  shrink-0" icon={faLocationDot} />
					<span className="truncate text-status-info">
						{`${row.prospect?.city ? `${row.prospect?.city}, ` : ""}${row.prospect?.country}`}
					</span>
				</>
			) : (
				""
			)}
		</div>
	);
};
